import { IBayLevelOffsetBottomBase, IOpenVesselDefinitionV1 } from "open-vessel-definition";

/**
 * Remaps the offset bottom bases stored in the file's `v3DParams` to `shipData.masterCGs`.
 *
 * The API used to store them as `bottomBase` next to the file instead of inside the OVD,
 * so a file fetched from the cloud needs this before it is opened or downloaded.
 */
export function remapOffsetBottomBasesToShipData(
  json: IOpenVesselDefinitionV1,
  offsetBottomBases: Array<IBayLevelOffsetBottomBase> | undefined,
): IOpenVesselDefinitionV1 {
  if (!offsetBottomBases) return json;

  offsetBottomBases.forEach((bb) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    bb.offset = (bb as any).bottomBase;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete (bb as any).bottomBase;
  });

  if (json.shipData.masterCGs) {
    json.shipData.masterCGs.offsetBottomBases = offsetBottomBases.filter(
      (bb) => bb.offset !== undefined && bb.offset !== 0,
    );
  } else {
    json.shipData.masterCGs = {
      aboveTcgs: {},
      belowTcgs: {},
      bottomBases: {},
      offsetBottomBases: offsetBottomBases.filter(
        (bb) => bb.offset !== undefined && bb.offset !== 0,
      ),
    };
  }

  return json;
}
